import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider } from 'antd';
import viVN from 'antd/lib/locale/vi_VN';

import reportWebVitals from "./reportWebVitals";
import App from "./App";

import "@Assets/css/index.css";
import "@Assets/less/App.less";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <ConfigProvider locale={viVN}>
        <App />
    </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
